  <app-collection-search [sessionID]="sessionID"  #collectionSearch (collectionAction)="addToCollection($event)"></app-collection-search>
  <app-collection-createtree></app-collection-createtree>
  <ng-template #template>
    <div class="modal-header headerBackground">
      Meldung
      <button type="button" class="close" aria-label="Close" (click)="d()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>{{icProps.message.messageText}}</p>
    </div>
    <div class="modal-footer">
      <span *ngFor="let msgOption of formMessageOptions">

        <button type="button" class="btn btn-secondary btn-sm btn-round" (click)="formStatePerUserAction(msgOption.TransitUserActionID,clickedUAIEID,null,'true',msgOption.optionID, null);modalRef.hide();">{{msgOption.option}}
        </button>
      </span>
    </div>
  </ng-template>

  <div>
    <div>
        <div *ngIf="showMessageBar" class="{{icProps.message.messageType}}" role="alert">
          <strong> {{icProps.message.messageText}} </strong>
        </div>
      <div class="pr-2" [formGroup]="formgroup">
        <!--<nav  [class]="fcAddStyle">-->
         
          <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
            <div *ngFor="let control of fcViews" class="ms-1"
              role="group" aria-label="First group">
              <button *ngIf="(control.TypeDID == IE_TYPES.Trigger )" 
                         type="button" 
                         class="btn btn-secondary btn-round btn-sm" 
                         [disabled]="!control.Attributes.Enabled" 
                         [id]="control.InterfaceElementID"
                         (click)='formStatePerUserAction(control.Attributes.OnClickUAID,control.InterfaceElementID, null, null, null, control.UserActions[0].ActionProcessOnServer);openModal(template,formMessageOptions.length)'
                         [title]="control.DisplayProperties.DisplayName">
                         <i [id]="control.TemplateID != null ? 'button_' + control.TemplateID : 'button_' + control.InterfaceElementID"></i>
                </button>
                <select  *ngIf="(control.TypeDID == IE_TYPES.InputPicklist )" 
                class="form-control form-control-sm select-default" 
                [formControlName]="control.InterfaceElementID">
                <option *ngFor="let controlOpt of control.options" 
                [value]="controlOpt.key" 
                [selected]="controlOpt.key == control.selected? true: null">
                  {{controlOpt.value}}
                </option>
              </select>
                
            </div>
            
            <div  *ngIf="uxControllerService.RTKeyAllowDynaEdit" class="form-dyna-editor-display px-2">
              <button type="button" (click)="uxControllerService.openDynaEditor(ie,dynaEditorTemplate)" class="btn btn-warning btn-sm">
                <i id="button_DynaEdit"></i>
              </button>
            </div>
         </div>
        

       <!--</nav>-->
      </div>
    </div>
  </div>
